import * as React from 'react';
import { clsx } from 'clsx';
import { UIText2 } from '@cian/ui-kit';

import { ISuggestionDefaultItem } from '../../../types';

import styles from './styles.module.css';

export const SuggestionMobileDefaultItem = React.forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<
    { isSelected: boolean; onClick(): void; iconMargin: number } & ISuggestionDefaultItem<unknown> &
      Pick<React.DOMAttributes<HTMLElement>, 'onMouseEnter' | 'onMouseMove' | 'onMouseLeave'>
  >
>((props, iconRef) => {
  return (
    <li
      className={clsx(styles['item'], props.isSelected && styles['item-selected'])}
      role="option"
      aria-selected={props.isSelected}
      tabIndex={-1}
      onClick={props.onClick}
      onMouseMove={props.onMouseMove}
      onMouseLeave={props.onMouseLeave}
      onMouseEnter={props.onMouseEnter}
      data-testid="suggesttion-mobile-default-item"
    >
      {props.leftIcon && (
        <div ref={iconRef} className={styles['left-icon']}>
          {props.leftIcon}
        </div>
      )}
      <div className={clsx(styles['text-area'])} style={{ marginLeft: props.iconMargin }}>
        <div className={styles['title']}>{props.children}</div>
        {props.subtitle && (
          <div className={styles['subtitle']}>
            <UIText2 color="text-primary-default">{props.subtitle}</UIText2>
          </div>
        )}
      </div>
      {props.rightIcon && <div className={styles['right-icon']}>{props.rightIcon}</div>}
    </li>
  );
});

SuggestionMobileDefaultItem.displayName = 'SuggestionMobileDefaultItem';
